<template>
  <v-data-table
    dense
    v-resize="onResize"
    id="time__table"
    fixed-header
    :items-per-page="-1" 
    :footer-props="{ itemsPerPageOptions: [-1] }"
    :headers="headers"
    :items="items"
    :sort-by="tablesortBy"
    :sort-desc="tablesortDesc"
    no-data-text="측정된 자료가 없습니다."
    class="table_content"
    item-key="date"
    single-select
    hide-default-header
    hide-default-footer
  >
    <template v-slot:header>
      <thead v-if="!isMobile">
        <tr>
          <th rowspan="2" @click="toggleSort('date')">경락일자</th>
          <th colspan="5" class="text-center group-header">육질등급</th>
          <th colspan="3">육량등급</th>
          <th rowspan="2">평균 <br/>(등외제외)</th>
          <th rowspan="2">등락</th>
        </tr>
        <tr>
          <th class="sub-header" style="top:40px !important;">1++</th>
          <th class="sub-header" style="top:40px !important;">1+</th>
          <th class="sub-header" style="top:40px !important;">1</th>
          
          <th class="sub-header" style="top:40px !important;">2</th>
          <th class="sub-header" style="top:40px !important;">3</th>
          
          <th class="sub-header" style="top:40px !important;">A</th>
          <th class="sub-header" style="top:40px !important;">B</th>
          <th class="sub-header" style="top:40px !important;">C</th>
        
        </tr>
      </thead>
    </template>

    <template v-slot:item="{ item }">
      <tr v-if="!isMobile">
        <td>{{ item.date }}</td>
        <td>{{ addCommas(item.auct_amt['1++']) }}</td>
        <td>{{ addCommas(item.auct_amt['1+']) }}</td>
        <td>{{ addCommas(item.auct_amt['1']) }}</td>
        <td>{{ addCommas(item.auct_amt['2']) }}</td>
        <td>{{ addCommas(item.auct_amt['3']) }}</td>
        <td>{{ addCommas(item.auct_amt['A']) }}</td>
        <td>{{ addCommas(item.auct_amt['B']) }}</td>
        <td>{{ addCommas(item.auct_amt['C']) }}</td>
        
        <td>{{ addCommas(item.avg_auct_amt) }}</td>
        <td :class="item.diff_auct_amt < 0 ? 'blue-text' : 'red-text'">
          <span v-if="item.diff_auct_amt < 0">▼</span>
          <span v-else>▲</span>
          <span style="display: inline-block; width: 30px !important;">{{ item.diff_auct_amt }}</span>
        </td>
      </tr>

      <tr v-else class="mobile_tr">
          <td class="mb_table">
            <div class="date mt-2">
              <div class="flex-title"> 발급일자</div>
              <div> {{ item.date }}</div>
            </div>

              <div class="flex">
                <div class="flex-title">육질등급</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight">1++</div>
                    <div> {{ addCommas(item.auct_amt["1++"]) }} 원 </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">1+</div>
                    <div> {{ addCommas(item.auct_amt["1+"]) }} 원 </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">1</div>
                    <div> {{ addCommas(item.auct_amt["1"]) }} 원 </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">2</div>
                    <div> {{ addCommas(item.auct_amt["2"]) }} 원 </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">3</div>
                    <div> {{ addCommas(item.auct_amt["3"]) }} 원 </div>
                  </div>
                </div>
                
                <div class="line-table"></div>
              </div>

              <div class="flex">
                <div class="flex-title">육량등급</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight">A</div>
                    <div> {{ addCommas(item.auct_amt["A"]) }} 원 </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">B</div>
                    <div> {{ addCommas(item.auct_amt["B"]) }} 원 </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">C</div>
                    <div> {{ addCommas(item.auct_amt["C"]) }} 원 </div>
                  </div>
                </div>
              </div>
              <div class="line-table"></div>

              <div class="flex s-bt">
                <div class="flex-title weight">평균 (등외제외)</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight"></div>
                    <div>  {{ addCommas(item.avg_auct_amt) }} 원</div>
                  </div> 
                </div>
              </div>

              <div  class="line-table"></div>


              <div class="flex s-bt">
                <div class="flex-title weight">등락</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight"></div>
                    <div :class="item.diff_auct_amt < 0 ? 'blue-text':'red-text'">  
                      <span v-if="item.diff_auct_amt < 0"> ▼ </span>
                      <span v-else> ▲ </span>
                      <span style="display: inline-block; width:30px !important;"> {{ item.diff_auct_amt }} </span>
                    </div>
                  </div> 
                </div>
              </div>
          </td>
        </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "CustomTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    sortBy: {
      type: String,
      default: "date",
    },
    sortDesc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isMobile: false,
      tablesortBy: this.sortBy,
      tablesortDesc: this.sortDesc,
    };
  },
  methods: {
    updateSortBy(value) {
      this.tablesortBy = value;
      this.$emit("update:sortBy", value); 
    },
    updateSortDesc(value) {
      this.tablesortDesc = value;
      this.$emit("update:sortDesc", value);
    },
    toggleSort(column) {
      if (this.tablesortBy === column) {
        this.tablesortDesc = !this.tablesortDesc; 
      } else {
        this.tablesortBy = column;
        this.tablesortDesc = false; 
      }

      this.$emit("update:sortBy", this.tablesortBy);
      this.$emit("update:sortDesc", this.tablesortDesc);
    },
    addCommas(num) {
      if (typeof num === "number") {
        return num.toLocaleString();
      }
      return num;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped lang="scss">
@import '../../../style/table_mb.scss';
.v-data-table th {
  text-align: center !important;
  vertical-align: middle !important;
}
.v-data-table td{
  text-align: center !important;
  vertical-align: middle !important;
}
:deep(.v-data-table__wrapper) {
  max-height: 45vh;
  overflow-y: auto;
  display: block;
}

:deep(.v-table thead tr:first-child th) {
  position: sticky;
  top: 0;
  z-index: 20;
  background-color: #005b96;
  color: white;
  height: 40px;
  text-align: center;
}


:deep(.v-table thead th.sub-header) {
  position: sticky;
  top: 40px !important; 
  z-index: 19;
  background-color: #005b96;
  color: white;
  height: 40px;
  text-align: center;
}
</style>
